var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLoadingIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 64,
    height: 64,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 6,
    x: 6
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 6,
    x: 39
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.125s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 6,
    x: 72
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.25s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 39,
    x: 6
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.875s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 39,
    x: 72
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.375s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 72,
    x: 6
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.75s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 72,
    x: 39
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.625s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eeeeee",
    height: 22,
    width: 22,
    y: 72,
    x: 72
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.5s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#635bff;#eeeeee;#eeeeee",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("g", null))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading-icon.75caed2e.svg";
export { ForwardRef as ReactComponent };